module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8283/img/blobsRight.png"